import { render, staticRenderFns } from "./blockYe.vue?vue&type=template&id=3b2f4d75&scoped=true&"
import script from "./blockYe.vue?vue&type=script&lang=js&"
export * from "./blockYe.vue?vue&type=script&lang=js&"
import style0 from "./blockYe.vue?vue&type=style&index=0&id=3b2f4d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f4d75",
  null
  
)

export default component.exports